import { render } from "./CaricamentoFilePerCmor.vue?vue&type=template&id=4e3fa6f8&scoped=true"
import script from "./CaricamentoFilePerCmor.vue?vue&type=script&lang=js"
export * from "./CaricamentoFilePerCmor.vue?vue&type=script&lang=js"

import "./CaricamentoFilePerCmor.vue?vue&type=style&index=0&id=4e3fa6f8&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3fa6f8"]])

export default __exports__